import { render, staticRenderFns } from "./textTemplate.vue?vue&type=template&id=4edeadd2&scoped=true&"
import script from "./textTemplate.ts?vue&type=script&lang=js&"
export * from "./textTemplate.ts?vue&type=script&lang=js&"
import style0 from "./textTemplate.less?vue&type=style&index=0&id=4edeadd2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4edeadd2",
  null
  
)

export default component.exports